import { makeOptions } from './tools'
import { TsEnum } from '@meta-vue/util-ts'

// 工单状态
export const WorkOrderStatus = {
  0: '待分配',
  1: '处理中',
  2: '关闭',
  3: '已关闭（系统）',
  6: '待确认',
  1001: '审核中',
  1002: '审核通过',
  1003: '已取消'
}

export const supplementarDocumentStatus = {
  0: '待补充凭证',
  1: '已撤销',
  2: '已完成',
  3: '已失效'
}

// 下拉菜单
export const WorkOrderStatusOptions = makeOptions(WorkOrderStatus)
export const supplementarDocumentStatusOptions = makeOptions(supplementarDocumentStatus)

// 投诉类型菜单
export const ComplainUserType = [
  {
    label: '全部投诉',
    value: ''
  },
  {
    label: '我发起的投诉',
    value: 1
  },
  {
    label: '我被投诉',
    value: 2
  }
]

// 责任认定
export const ResponsibleParties = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 1,
    label: '投诉人责任'
  },
  {
    value: 2,
    label: '被投诉人责任'
  },
  {
    value: 3,
    label: '双方责任'
  },
  {
    value: 4,
    label: '责任不清'
  }
]

// 灰度用户，主要为了解决：avaya 长连接不稳定，重连失败等问题
export const avayaSocketUserWhiteList = [
  371,
  1025835,
  1023666,
  1022557,
  1023668,
  1024006,
  1020428,
  1024126,
  1023231,
  1024362,
  1024978
] // 默认值目前为零担团队负责接线的人员

export const CUSTOMER_STATUS = new TsEnum([
  ['注销', -2, 'CANCEL'],
  ['未认证', 0, 'NO_CERTIFICATE'],
  ['已认证', 1, 'CERTIFICATE']
])

export const needTrackWorkBenchTypeList = ['im', 'callin', 'crmcall']

export const EXTENSION_TYPE = new TsEnum([
  ['普通外呼', 1, 'OUT'],
  ['95006进线', 2, 'IN'],
  ['区域进线', 3, 'REGION'],
  ['商户进线', 4, 'MERCHANT'],
  ['创新进线', 5, 'LCL'],
  ['零担进线', 6, 'LTL'],
  ['平台进线', 7, 'PLATFORM'],
  ['AI转人工', 8, 'AI_TRANSFER'],
  ['大增值-冷运', 9, 'COLD'],
  ['区域-项目贷', 10, 'REGION_PROJECT']
])

export const USER_CONFIG_TYPE = new TsEnum([['呼叫配置', 1, 'CALL_CONFIG']])
// 工单状态
export const WORK_TYPE_ENUMS = new TsEnum([
  ['投诉单', 0, 'COMPLAINT'],
  ['待补充凭证工单', 1, 'VOUCHER_WORK_ORDER']
])

// 同步来源
export const SYNCHRONIZATION_TYPE = new TsEnum([
  ['单点同步', 0, 'DANDIAN'],
  ['SOP', 1, 'SOP'],
  ['发起投诉同步', 2, 'COMPLAINT']
])

// 同步单据类型
export const SYNCHRONIZE_DOCUMENT_TYPES = new TsEnum([
  ['运单', 0, 'BUSINESSNO'],
  ['投诉单', 1, 'COMPLAINCASENO'],
  ['货源', 2, 'CARGOID'],
  ['其他', 3, 'OTHER']
])
